import React from 'react'
import { Router } from '@reach/router'
import ScanSettingsView from './ScanSettingsView'
import Scans from './Scans'
import Scan from './Scan'
import ScanCompare from './ScanCompare'
import NewSimpleScan from './NewSimpleScan'
import NewScan from './NewScan'

function ScanSettings() {
	return (
			<Router>
				<ScanSettingsView path="/" />
				<Scans path=":scanSettingsId/scans" />
				<Scan path=":scanSettingsId/scan/:scanId" />
				<ScanCompare path=":scanSettingsId/scan-compare/:scanA/:scanB" />
				<NewSimpleScan path="new-simple-scan" />
				<NewScan path="new-scan" />
			</Router>
	)
}

export default ScanSettings
